import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "entry-page",
    templateUrl: "./entry-page.component.html",
    styleUrls: ["./entry-page.component.scss"]
})
export class EntryPageComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {

    const redirectUrl = localStorage.getItem('redirectUrl')

    if(redirectUrl){
      console.log('entry-page rederict',redirectUrl)
      localStorage.removeItem('redirectUrl');
      this.router.navigateByUrl(redirectUrl);
    }
  }

}
